import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import SEO from '../components/SEO';
import Pricing from '../components/Pricing';
import { useLocale } from '../i18n/LocaleContext';

const PaymentPage = () => {
  const { t, appLink } = useLocale();
  const { pathname, search } = useLocation();
  const returned = pathname.includes('payment-success') || new URLSearchParams(search).has('session_id');
  const cancelled = pathname.includes('payment-cancelled');
  return <PageContainer>
    <SEO title={t('nav.pricing')} description={t('seo.pricing')} canonicalPath="/pricing" noindex={returned || cancelled} />
    {returned && <p role="status">{t('payment.verify')} <a href={appLink()}>{t('payment.openApp')}</a></p>}
    {cancelled && <p role="status">{t('payment.cancelled')}</p>}
    <Pricing />
    <FAQ>
      <SectionTitle>{t('pricing.faq')}</SectionTitle>
      <FAQItem><FAQQuestion>{t('pricing.trialQuestion')}</FAQQuestion><FAQAnswer>{t('pricing.trialAnswer')}</FAQAnswer></FAQItem>
      <FAQItem><FAQQuestion>{t('pricing.cancelQuestion')}</FAQQuestion><FAQAnswer>{t('pricing.cancelAnswer')}</FAQAnswer></FAQItem>
    </FAQ>
  </PageContainer>;
};

// Styled Components
const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px;
  position: relative;

  @media (max-width: 768px) {
    padding: 80px 20px;
  }
`;

const FAQ = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 40px;
  color: var(--primary);
  font-weight: 700;
`;

const FAQItem = styled.div`
  margin-bottom: 25px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 25px;

  &:last-child {
    border-bottom: none;
  }
`;

const FAQQuestion = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--primary-dark);
`;

const FAQAnswer = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: var(--dark-gray);
`;
export default PaymentPage;
